<template>
  <div class="data-empty">
    <img src="@/assets/dataempty.png">
    <span>暂无数据</span>
  </div>
</template>

<script>
  export default {
    name: "DataEmpty"
  }
</script>

<style scoped lang="less">
  @import "../../../styles/mycss.less";
</style>
